import React from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import Loading from "components/Global/Loading";

const PlatformLoading = ({ message = "" }) => {
  return (
    <div styleName="loadingWrapper">
      <Loading content={message || "Loading..."} />
    </div>
  );
};

export default CSSModules(PlatformLoading, css);
